/*
 * Cloud 9 Carousel 2.2.0 (PC & Mobile Independent Engine)
 * Added: AutoPlay engine with hover/touch pause interactions.
 */
;(function($) {
    var transform = (function() {
      var vendors = ['webkit', 'moz', 'ms'];
      var style   = document.createElement( "div" ).style;
      var trans   = 'transform' in style ? 'transform' : undefined;
      for( var i = 0, count = vendors.length; i < count; i++ ) {
        var prop = vendors[i] + 'Transform';
        if( prop in style ) { trans = prop; break; }
      }
      return trans;
    })();
  
    var Item = function( element, options ) {
      element.item = this;
      this.element = element;
  
      if( element.tagName === 'IMG' ) {
        this.fullWidth = element.width;
        this.fullHeight = element.height;
      } else {
        element.style.display = "inline-block";
        this.fullWidth = element.offsetWidth;
        this.fullHeight = element.offsetHeight;
      }
      element.style.position = 'absolute';
  
      if( options.mirror && this.element.tagName === 'IMG' ) {
        this.reflection = $(element).reflect( options.mirror ).next()[0];
        var $reflection = $(this.reflection);
        this.reflection.fullHeight = $reflection.height();
        $reflection.css( 'margin-top', options.mirror.gap + 'px' );
        $reflection.css( 'width', '100%' );
        element.style.width = "100%";
        this.element = this.element.parentNode;
        this.element.item  = this;
        this.element.alt   = element.alt;
        this.element.title = element.title;
      }
  
      if( transform && options.transforms )
        this.element.style[transform + "Origin"] = "50% 50%"; 
  
      this.moveTo = function( x, y, scale, tilt, depth, isMobile ) {
        this.width = this.fullWidth * scale;
        this.height = this.fullHeight * scale;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.tilt = tilt || 0;
  
        var style = this.element.style;
        style.zIndex = Math.round((depth + 1) * 100);

        if (isMobile) {
            var alpha = Math.min(1, Math.max(0, (depth + 0.2) * 2));
            style.opacity = alpha;
            style.pointerEvents = alpha > 0.5 ? 'auto' : 'none';
            style.visibility = alpha === 0 ? 'hidden' : 'visible';
        } else {
            style.opacity = 1;
            style.pointerEvents = 'auto';
            style.visibility = 'visible';
        }
  
        if( transform && options.transforms ) {
          style[transform] = "translate(" + x + "px, " + y + "px) rotate(" + this.tilt + "deg)";
        } else {
          if( options.mirror && this.element.tagName === 'IMG' )
            this.reflection.style.marginTop = (options.mirror.gap * scale) + "px";
          style.width = this.width + "px";
          style.left = x + "px";
          style.top = y + "px";
        }
      }
    }
  
    var time = !window.performance || !window.performance.now ?
      function() { return +new Date() } : function() { return performance.now() };
  
    var cancelFrame = window.cancelAnimationFrame || window.cancelRequestAnimationFrame;
    var requestFrame = window.requestAnimationFrame;
    (function() {
      var vendors = ['webkit', 'moz', 'ms'];
      for( var i = 0, count = vendors.length; i < count && !cancelFrame; i++ ) {
        cancelFrame = window[vendors[i]+'CancelAnimationFrame'] || window[vendors[i]+'CancelRequestAnimationFrame'];
        requestFrame = requestFrame && window[vendors[i]+'RequestAnimationFrame'];
      }
    }());
  
    var Carousel = function( element, options ) {
      var self = this;
      var $container = $(element);
      this.items = [];
      
      this.updateDims = function() {
        var w = $container.width();
        var h = $container.height();
        self.isMobile = $(window).width() <= 768;

        var xRadFactor = self.isMobile ? (options.xRadiusMobile / 100) : (options.xRadiusPc / 100);
        var yRadFactor = self.isMobile ? (options.yRadiusMobile / 100) : (options.yRadiusPc / 100);
        var yOrgFactor = self.isMobile ? (options.yOriginMobile / 100) : (options.yOriginPc / 100);

        self.xOrigin = w * 0.5; 
        self.yOrigin = h * yOrgFactor;
        self.xRadius = w * xRadFactor;
        self.yRadius = h * yRadFactor;
        self.tiltAngle = self.isMobile ? options.tiltAngleMobile : options.tiltAnglePc;
      };

      this.updateDims(); 

      $(window).bind('resize.cloud9', function() {
        self.updateDims();
        self.render(); 
      });
      
      this.farScale = options.farScale;
      this.rotation = this.destRotation = Math.PI/2; 
      this.speed = options.speed;
      this.smooth = options.smooth;
      this.fps = options.fps;
      this.timer = 0;
      this.autoPlayAmount = 0; 
      this.autoPlayDelay = options.autoPlayDelay;
      this.autoPlayTimer = 0;
      this.frontItemClass = options.frontItemClass;
      this.onLoaded = options.onLoaded;
      this.onRendered = options.onRendered;
      this.onAnimationFinished = options.onAnimationFinished;
  
      this.itemOptions = { transforms: options.transforms }
      if( options.mirror ) { this.itemOptions.mirror = $.extend( { gap: 2 }, options.mirror ); }
  
      $container.css( { position: 'relative', overflow: 'hidden' } );
  
      this.renderItem = function( itemIndex, rotation ) {
        var item = this.items[itemIndex];
        var sin = Math.sin(rotation);
        var cos = Math.cos(rotation); 
        var farScale = this.farScale;
        var scale = farScale + ((1-farScale) * (sin+1) * 0.5);
  
        var cx = this.xOrigin + (scale * cos * this.xRadius);
        var cy = this.yOrigin + (scale * sin * this.yRadius);
        var tilt = cos * self.tiltAngle; 
  
        item.moveTo(cx - (item.fullWidth * 0.5), cy - (item.fullHeight * 0.5), scale, tilt, sin, self.isMobile);
        return item;
      }
  
    this.render = function() {
        var count = this.items.length;
        var spacing = 2 * Math.PI / count;
        var radians = this.rotation;
        var nearest = this.nearestIndex();
        
        var prev = (nearest - 1 + count) % count;

        for( var i = 0; i < count; i++ ) {
          var item = this.renderItem( i, radians );
          
          if( i === nearest ) {
            $(item.element).addClass( this.frontItemClass );
            $(item.element).removeClass('prev-item'); 
          } 
          else if( i === prev ) {
            $(item.element).addClass('prev-item');
            $(item.element).removeClass( this.frontItemClass );
          }
          else {
            $(item.element).removeClass( this.frontItemClass );
            $(item.element).removeClass('prev-item');
          }
          radians += spacing;
        }
        if( typeof this.onRendered === 'function' ) this.onRendered( this );
    }
  
      this.playFrame = function() {
        var rem = self.destRotation - self.rotation;
        var now = time();
        var dt = (now - self.lastTime) * 0.002;
        self.lastTime = now;
        if( Math.abs(rem) < 0.003 ) {
          self.rotation = self.destRotation;
          self.pause();
          if( typeof self.onAnimationFinished === 'function' ) self.onAnimationFinished();
        } else {
          self.rotation = self.destRotation - rem / (1 + (self.speed * dt));
          self.scheduleNextFrame();
        }
        self.render();
      }
  
      this.scheduleNextFrame = function() {
        this.lastTime = time();
        this.timer = this.smooth && cancelFrame ? requestFrame( self.playFrame ) : setTimeout( self.playFrame, 1000 / this.fps );
      }
  
      this.itemsRotated = function() {
        return this.items.length * ((Math.PI/2) - this.rotation) / (2*Math.PI);
      }
      this.floatIndex = function() {
        var count = this.items.length;
        var floatIndex = this.itemsRotated() % count;
        return (floatIndex < 0) ? floatIndex + count : floatIndex;
      }
      this.nearestIndex = function() { return Math.round( this.floatIndex() ) % this.items.length; }
      this.nearestItem = function() { return this.items[this.nearestIndex()]; }
      this.play = function() { if( this.timer === 0 ) this.scheduleNextFrame(); }
      this.pause = function() { this.smooth && cancelFrame ? cancelFrame( this.timer ) : clearTimeout( this.timer ); this.timer = 0; }
      this.go = function( count ) { this.destRotation += (2 * Math.PI / this.items.length) * count; this.play(); }
      
      this.goTo = function( index ) {
        var count = this.items.length;
        var diff = index - (this.floatIndex() % count);
        if( 2 * Math.abs(diff) > count ) diff -= (diff > 0) ? count : -count;
        this.destRotation = this.rotation;
        this.go( -diff );
        return diff;
      }
  
      this.deactivate = function() {
        this.pause();
        clearInterval( this.autoPlayTimer );
        if( options.buttonLeft ) options.buttonLeft.unbind( 'click' );
        if( options.buttonRight ) options.buttonRight.unbind( 'click' );
        $container.unbind( '.cloud9' );
        $(window).unbind('resize.cloud9');
      }

      // 🔥 激活核心自动轮播功能
      this.enableAutoPlay = function() {
        if( options.autoPlay ) {
          clearInterval( self.autoPlayTimer );
          self.autoPlayTimer = setInterval( function() {
            self.go( 1 ); // 1 表示顺时针走一张
          }, options.autoPlayDelay );
        }
      }
  
      this.bindControls = function() {
        var startX = 0;
        var startY = 0;
        var startRotation = 0;
        var isDragging = false;
        var hasMoved = false;

        var getClientX = function(e) {
            if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
                return e.originalEvent.touches[0].clientX;
            }
            return e.clientX || 0;
        };
        var getClientY = function(e) {
            if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
                return e.originalEvent.touches[0].clientY;
            }
            return e.clientY || 0;
        };

        // 🔥 鼠标移入时暂停轮播
        $container.bind('mouseenter', function() {
            clearInterval(self.autoPlayTimer);
        });

        $container.bind('mousedown touchstart', function(e) {
            clearInterval(self.autoPlayTimer); // 🔥 手指按下时暂停
            startX = getClientX(e);
            startY = getClientY(e);
            startRotation = self.rotation;
            isDragging = true;
            hasMoved = false;
            self.pause(); 
        });

        $container.bind('mousemove touchmove', function(e) {
            if (!isDragging) return;
            var currentX = getClientX(e);
            var currentY = getClientY(e);
            var diffX = currentX - startX;
            var diffY = currentY - startY;

            if (Math.abs(diffX) > 5 && Math.abs(diffX) > Math.abs(diffY)) {
                hasMoved = true;
                if (e.type === 'touchmove') e.preventDefault(); 

                var itemAngle = 2 * Math.PI / self.items.length;
                var moveFactor = diffX / $container.width();
                
                var sensitivity = self.isMobile ? options.dragSensitivityMobile : options.dragSensitivityPc;

                self.destRotation = startRotation - (moveFactor * itemAngle * sensitivity);
                self.rotation = self.destRotation; 
                self.render(); 
            }
        });

        // 🔥 手指或鼠标松开、离开时恢复自动轮播
        $container.bind('mouseup mouseleave touchend', function(e) {
            if (!isDragging) {
                self.enableAutoPlay();
                return;
            }
            isDragging = false;
            if (hasMoved) {
                var nearest = self.nearestIndex();
                self.goTo(nearest);
            }
            self.enableAutoPlay();
        });

        $container.find('img').bind('dragstart', function(e) { e.preventDefault(); }); 

        if( options.bringToFront ) {
          $container.bind( 'click.cloud9', function( event ) {
            if (hasMoved) {
              event.preventDefault();
              return false;
            }
            var hits = $(event.target).closest( '.' + options.itemClass );
            if( hits.length !== 0 ) {
              var diff = self.goTo( self.items.indexOf( hits[0].item ) );
              if( Math.abs(diff) > 0.5 ) event.preventDefault();
            }
          } );
        }
      }
  
      var items = $container.find( '.' + options.itemClass );
  
      this.finishInit = function() {
        for( var i = 0; i < items.length; i++ ) {
          var item = items[i];
          if( (item.tagName === 'IMG') && ((item.width === undefined) || ((item.complete !== undefined) && !item.complete)) )
            return;
        }
        clearInterval( this.initTimer );
        for( i = 0; i < items.length; i++ ) this.items.push( new Item( items[i], this.itemOptions ) );
        $container.bind( 'selectstart', function() { return false } );
        this.bindControls();
        this.render();
        this.enableAutoPlay(); // 🔥 初始化完成后立刻启动自动轮播
        if( typeof this.onLoaded === 'function' ) this.onLoaded( this );
      };
      this.initTimer = setInterval( function() { self.finishInit() }, 50 );
    }
  
    $.fn.Cloud9Carousel = function( options ) {
      return this.each( function() {
        options = $.extend( {
          xOrigin: null, yOrigin: null, xRadius: null, yRadius: null,
          xRadiusPc: 32, yRadiusPc: 16, yOriginPc: 35,
          xRadiusMobile: 33, yRadiusMobile: 12, yOriginMobile: 40,
          dragSensitivityPc: 1.0, dragSensitivityMobile: 0.4,
          farScale: 0.85, tiltAnglePc: 6.5, tiltAngleMobile: 6.5, 
          transforms: true, smooth: true, fps: 30, speed: 4,
          autoPlay: false, autoPlayDelay: 4000, bringToFront: false, // 默认不开启，受控于 Liquid
          itemClass: 'cloud9-item', frontItemClass: 'active', handle: 'carousel'
        }, options );
        $(this).data( options.handle, new Carousel( this, options ) );
      } );
    }
})( window.jQuery || window.Zepto );